var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: "12" } },
    [
      _c("app-filter-input", {
        style: { flexGrow: 1 },
        attrs: {
          "field-type": _vm.fieldType,
          label: _vm.$ct("common.filter.value"),
        },
        model: {
          value: _vm.value.Values[0],
          callback: function ($$v) {
            _vm.$set(_vm.value.Values, 0, $$v)
          },
          expression: "value.Values[0]",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }